module.exports = __webpack_public_path__ + "static/scale-model-of-street-art-in-san-jose-california-354663cc8ef702189e70a89a48f4c83f.png";